export default __webpack_public_path__ + "static/media/Last Page.4bdfa2f1.png";